import React, {useEffect, useState} from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {useCourt, useForwardingOrg, useRequestUrl} from "../context/contextHooks";
import { oldBrowserMessage } from "../global/utils";
import { useStyles as classes } from "../styles/styles";
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from "@mui/material/CircularProgress";
import CustomLandingPage from "../home/CustomLandingPage";
import Home from "../home/Home";
import API from "../http/API";
import Popup from "../layout/Popup";
import Typography from "@mui/material/Typography";

const LandingPageSource = (props) => {
    const [partyId, setPartyId] = useState(props.partyId);
    const courtId = props.court;
    const agencyId = props.agencyId;
    const navigate = useNavigate();
    const location = useLocation();
    const [, setCourt] = useCourt();
    const [forwardingOrg, setForwardingOrg] = useForwardingOrg();
    const [requestUrl,] = useRequestUrl();
    const [actionResponse, setActionResponse] = useState(null);
    const [lookupDone, setLookupDone] = useState(false);
    const Navigator = window.navigator;
    const [openPopup, setOpenPopup] = useState(false);
    const [browserMsg, setBrowserMsg] = useState(null);

    const closePopup = () => {
        setOpenPopup(false);
    }

    useEffect(() => {
        if (courtId || agencyId) {
            const lookupId = courtId ? courtId : agencyId;
            const url = `${requestUrl}/getOrgByLink/${lookupId}`;
            API.getRetrieve(url, 'getOrg', null, setActionResponse);
        } else setLookupDone(true);
    }, [courtId, agencyId])

    useEffect(() => {
        if (actionResponse) {
            if (!actionResponse.error && actionResponse.data) {
                const org = actionResponse.data;
                setForwardingOrg(org);
            } else setLookupDone(true);
        }
    }, [actionResponse])

    useEffect(() => {
        if (forwardingOrg && !lookupDone) {
            setCourt(forwardingOrg);
            if (partyId) {
                const url = '/balanceLookup';
                const state = {courtId: forwardingOrg.courtId, partyId: partyId};
                setPartyId(null);
                navigate(url, {replace: false, state});
            } else setLookupDone(true);
        }
    }, [forwardingOrg])

    useEffect(() => {
        if (!forwardingOrg && location && location.state && location.state.court) {
            setForwardingOrg(location.state.court);
        }
    }, [location])

    useEffect(() => {
        if (Navigator && browserMsg === null) {
            const userAgent = Navigator.userAgent;
            setBrowserMsg(oldBrowserMessage(userAgent));
            setOpenPopup(true);
        }
    }, [browserMsg]);

    return (
        <>
            { browserMsg && openPopup &&
                <Popup
                    open={openPopup}
                    setDone={closePopup}
                    title="Browser Compatibility Notice"
                    component={<Typography variant='subtitle2' color='secondary' sx={{fontSize: '15pt', margin: '1rem 2rem'}}>{browserMsg}</Typography>}
                />
            }
            {!lookupDone ?
                <Backdrop open={!lookupDone} sx={classes.backdrop}>
                    <CircularProgress color='inherit' />
                </Backdrop> :
                <>
                    { forwardingOrg ?
                        <>
                            { forwardingOrg.landingPageConfig && forwardingOrg.landingPageConfig.title ?
                                <CustomLandingPage uiConfig={forwardingOrg.landingPageConfig} /> :
                                <>
                                    <Home />
                                </>
                            }
                        </> :
                        <Home />
                    }
                </>
            }
        </>
    )

}

export default LandingPageSource;